// frontend/src/pages/Meetings/MeetingsReviewPage.jsx
// Cola de revisión manual: reuniões agendadas no Calendar sem oportunidade ligada.
import React, { useState } from 'react';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { getMeetingsReview, linkMeeting } from '../../services/api';

function fmt(dt) {
  if (!dt) return '—';
  try {
    return new Date(dt).toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' });
  } catch {
    return dt;
  }
}

export default function MeetingsReviewPage() {
  const qc = useQueryClient();
  const { data, isLoading } = useQuery(
    ['meetings-review'],
    getMeetingsReview
  );
  const [inputs, setInputs] = useState({});
  const mut = useMutation(
    ({ id, opportunityId }) => linkMeeting(id, opportunityId),
    {
      onSuccess: () => qc.invalidateQueries(['meetings-review']),
    }
  );

  const meetings = (data && data.meetings) || [];

  return (
    <div className="p-6">
      <h1 className="text-xl font-semibold mb-1">Reuniões por ligar</h1>
      <p className="text-sm text-gray-500 mb-4">
        Reuniões agendadas no Calendar que não casaram automaticamente com uma oportunidade. Cole o ID da oportunidade para ligar.
      </p>
      {isLoading && <p>Carregando…</p>}
      {!isLoading && meetings.length === 0 && (
        <p className="text-gray-500">Nada por ligar. 🎉</p>
      )}
      <div className="space-y-3">
        {meetings.map((m) => (
          <div key={m.id} className="border rounded-lg p-4 flex items-start justify-between gap-4">
            <div>
              <div className="font-medium">{m.title || 'Reunião'}</div>
              <div className="text-sm text-gray-600">
                {m.booker_name || '—'} · {m.attendee_email || 'sem e-mail'} · {fmt(m.scheduled_at)}
              </div>
              {m.match_suggestion && (
                <div className="text-xs text-amber-600 mt-1">
                  Motivo: {m.match_suggestion.reason}
                </div>
              )}
            </div>
            <div className="flex items-center gap-2">
              <input
                className="border rounded px-2 py-1 text-sm w-64"
                placeholder="ID da oportunidade"
                value={inputs[m.id] || ''}
                onChange={(e) => setInputs((s) => ({ ...s, [m.id]: e.target.value }))}
              />
              <button
                className="bg-blue-600 text-white text-sm rounded px-3 py-1 disabled:opacity-50"
                disabled={!inputs[m.id] || mut.isLoading}
                onClick={() => mut.mutate({ id: m.id, opportunityId: inputs[m.id] })}
              >
                Ligar
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
